<template>
  <l-cache :get-data="getGroupType" :id="$route.query.id" ref="cache">
    <type-form slot-scope="{data}" :groupType="data"></type-form>
  </l-cache>
</template>

<script>

import TypeForm from './typeForm'
export default {
  name: 'EditGroupType',
  components: {TypeForm},
  data: () => ({
  }),
  methods: {
    async getGroupType () {
      let {items} = await this.$store.dispatch('userAdmin/getGroupTypes', {
        pagination: {},
        filter: [{key: 'id', value: this.$route.query.id}],
      })
      if (items && items.length > 0) {
        let p = items[0]
        return p
      }
      else {
        throw Error('未找到该分组类型')
      }
    },
  }
}
</script>

<style scoped>

</style>
